const url = {
  auth: {
    host: process.env.auth.host,
    methods: {
      login: '/api/v1/user/auth/access_token',
      logout: '',
      logoutAllUserByShop: '/api/v1/user/auth/logout/company/%s'
    }
  },
  shop: {
    host: process.env.auth.host,
    methods: {
      listAll: '/companies/webadmin/v1.1/shops',
      getById: '/companies/webadmin/v1.1/shops/%s',
      edit: '/companies/webadmin/v1.1/shops/%s',
      createShop: '/companies/webadmin/v1.1/shops',
      reset: '/users/webadmin/v1.1/shops/%s/password/reset'
    }
  },
  cash: {
    host: process.env.auth.host,
    methods: {
      listByShop: '/companies/webadmin/v1.1/shops/%s/cashboxes',
      getById: '/companies/webadmin/v1.1/shops/%s/cashboxes/%s',
      edit: '/companies/webadmin/v1.1/shops/%s/cashboxes/%s'
    }
  },
  users: {
    host: process.env.auth.host,
    methods: {
      listByShop: '/users/webadmin/v1.1/shops/%s/users',
      getById: '/users/webadmin/v1.1/shops/%s/users/%s',
      edit: '/users/webadmin/v1.1/shops/%s/users/%s',
      resetPassword: '/users/webadmin/v1.1/shops/%s/users/%s/password/reset',
      search: '/users/webadmin/v1.1/shops/users',
      create: '/users/webadmin/v1.1/shops/users'
    }
  },
  dictionaries: {
    host: process.env.auth.host,
    methods: {
      cities: '/companies/v1.1/dictionaries/cities'
    }
  },
  requests: {
    host: process.env.auth.host,
    methods: {
      registrationListAll: '/requests/v1.1/registration/find',
      getById: '/requests/v1.1/registration/%s',
      edit: '/requests/v1.1/registration/%s'
    }
  }
}

const generateUrl = function (method) {
  let pathMethod = method.split('.')
  return url[pathMethod[0]]['host'] + url[pathMethod[0]]['methods'][pathMethod[1]]
}

export default {
  generateUrl
}



// WEBPACK FOOTER //
// ./src/api/methods/index.js